import { createIcon } from '../createIcon';
import { ReactComponent as IconCrown } from '../svg/crown.svg';

export default createIcon(IconCrown);
